module.exports = __webpack_public_path__ + "assets/img/role-983aa023.png";